<h1 ev-dialog-title>{{ languageService.languageJSON.TabbedInfoDialog_Tutorial }}</h1>

<div ev-dialog-content #tutorialScrollbar class="scrollable" data-testid="tutorial-container">
  <div class="tutorial-content">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </div>
</div>

<div ev-dialog-actions>
  <button class="ev-button primary" name="ok_button" mat-button (click)="dialogRef?.close()" data-testid="tutorial-close-btn">
    {{ languageService.languageJSON.Global_Close }}
  </button>
</div>

<ng-template #contentTpl>

  <!-- Standalone mode: show all steps stacked -->
  @for (item of contentArr; track $index) {
    <ng-container *ngTemplateOutlet="stepTpl; context: { item: item }"></ng-container>
  }

  <!-- Hidden image preloader (kept from original) -->
  <img style="display: none" [src]="'assets/screenshots/' + settingsService.getMap().Skin + '/range_image.jpg?v=3'" alt="" />
  <img style="display: none" [src]="'assets/screenshots/' + settingsService.getMap().Skin + '/search_click_image.jpg?v=3'" alt="" />
  <img style="display: none" [src]="'assets/screenshots/' + settingsService.getMap().Skin + '/voice_instruction_image.jpg?v=3'" alt="" />
</ng-template>

<ng-template #stepTpl let-item="item">

  @if (item.img) {
    <div class="tutorial-media">
      <img class="tutorial-img" [src]="item.img" alt="" />
    </div>
  }

  @if (item.mp4) {
    <div class="tutorial-media">
      <video class="tutorial-video" width="560" playsinline muted="muted" loop="loop" autoplay="autoplay">
        <source [src]="item.mp4" type="video/mp4">
      </video>
    </div>
  }

  <app-modal-option-panel>
    <span panel-title [innerHtml]="item.title"></span>
    <p class="tutorial-text" [innerHtml]="item.text"></p>

    @if (item.commands?.length) {
      <div class="tutorial-commands">
        @for (command of item.commands; track command) {
          <span class="tutorial-command">{{ command }}</span>
        }
      </div>
    }
  </app-modal-option-panel>
</ng-template>
